<template>
  <li class="accordion-item" :class="{ opened: isOpened }">
    <div class="title" v-if="!$slots.title">
      <b>{{ title }}</b>
    </div>
    <div class="title" v-else>
      <slot name="title"></slot>
    </div>
    <div class="content" v-show="$slots.content">
      <slot name="content"></slot>
    </div>
  </li>
</template>
<script>
export default {
  props: {
    title: String,
    isOpened: {
      type: Boolean,
      default: true
    }
  }
}
</script>